import { Routes } from '@angular/router';
import { MainComponent } from '../main.component';

// Import migrated route modules
import { accountsRoutes } from './accounts.routes';
import { announcementsRoutes } from './announcements.routes';
import { blueprintsRoutes } from './blueprints.routes';
import { bulkActionsRoutes } from './bulk-actions.routes';
import { dashboardTemplatesRoutes } from './dashboard-templates.routes';
import { emailsRoutes } from './emails.routes';
import { eventTypesRoutes } from './event-types.routes';
import { faqsRoutes } from './faqs.routes';
import { filesRoutes } from './files.routes';
import { organisationsRoutes } from './organisations.routes';
import { profileTemplatesRoutes } from './profile-templates.routes';
import { relationsRoutes } from './relations.routes';
import { rolesRoutes } from './roles.routes';
import { settingsRoutes } from './settings.routes';
import { userFieldsRoutes } from './user-fields.routes';
import { dashboardRoutes } from './dashboard.routes';
import { adminRoutes } from './admin.routes';
import { eventsRoutes } from './events.routes';
import { usersRoutes } from './users.routes';
import { reportsRoutes } from './reports.routes';
import { goalsRoutes } from './goals.routes';
import { UpgradeRequiredComponent } from '../upgrade-required.component';
import { initGuard } from '@fry/upgrade/init.guard';
import { RisrNotFound } from '@fry-it/risr-core';

export const routes: Routes = [
  // Must come before the '' shell below: its '**' child would otherwise swallow these paths
  ...accountsRoutes,
  { path: 'upgrade-required', component: UpgradeRequiredComponent },
  {
    path: '',
    component: MainComponent,
    canActivate: [initGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      ...dashboardRoutes,
      ...announcementsRoutes,
      ...blueprintsRoutes,
      ...bulkActionsRoutes,
      ...dashboardTemplatesRoutes,
      ...emailsRoutes,
      ...eventTypesRoutes,
      ...faqsRoutes,
      ...filesRoutes,
      ...organisationsRoutes,
      ...profileTemplatesRoutes,
      ...relationsRoutes,
      ...rolesRoutes,
      ...settingsRoutes,
      ...userFieldsRoutes,
      ...adminRoutes,
      ...eventsRoutes,
      ...usersRoutes,
      ...reportsRoutes,
      {
        path: 'report-management',
        loadChildren: () => import('@fry-it/risr-features/report-management').then(m => m.reportRoutes as Routes),
      },
      {
        path: 'reports',
        loadChildren: () => import('@fry-it/risr-features/reports').then(m => m.reportRoutes as Routes),
      },
      {
          path: 'indexing-status',
          loadChildren: () => import('@fry-it/risr-features/indexing-status').then(m => m.indexingStatusRoutes),
      },
      {
          path: 'trash',
          loadChildren: () => import('@fry-it/risr-features/trash').then(m => m.trashRoutes as Routes),
      },
      ...goalsRoutes,
      // Add other routes as they are migrated
      {
        path: '**',
        component: RisrNotFound,
        title: $localize`Page not found`,
      }
    ]
  },
];
